import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'react-toolbox';
import { formatTelephone } from '../../../../utils';

class PhoneInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
  }

  static defaultProps = {
    value: '',
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    this.props.onChange(value);
  }

  render() {
    const newProps = {
      ...this.props,
      value: formatTelephone(this.props.value),
      onChange: this.handleChange,
      type: 'tel',
    };
    return (<Input {...newProps} />);
  }
}

export default PhoneInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/PhoneType/PhoneInput/index.jsx